import React from "react";
import PropTypes from "prop-types";

class StickyContainer extends React.Component {
  componentDidMount = () => {
    const timeout = 1000 / 60;
    const updateStickyStatus = () => {
      if (!(this.content && this.container)) {
        return;
      }

      const { top } = this.container.getBoundingClientRect();

      const { height } = this.content.getBoundingClientRect();

      if (top <= 0) {
        this.content.classList.add("is-sticky");
      } else {
        this.content.classList.remove("is-sticky");
        this.container.style.minHeight = `${height}px`;
      }

      setTimeout(() => {
        requestAnimationFrame(updateStickyStatus);
      }, timeout);
    };
    requestAnimationFrame(updateStickyStatus);
  };

  render = () => {
    const { children } = this.props;

    return (
      <div
        className="sticky-container"
        ref={(c) => {
          this.container = c;
        }}
      >
        <div
          className="sticky-container__content"
          ref={(c) => {
            this.content = c;
          }}
        >
          {children}
        </div>
      </div>
    );
  };
}

StickyContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

export default StickyContainer;
